export default "__VITE_ASSET__67a01f0f__"